<template>
  <div
    class="sidebar"
    :style="sidebarStyle"
    :data-color="backgroundColor"
    :data-image="backgroundImage"
    :data-active-color="activeColor"
  >
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <div class="static-content">
        <div class="hilo-logo-container">
          <img class="hilo-logo" alt="" src="/static/img/HiloMainLogo.svg" />
        </div>
      </div>
      <div class="scrollable-content">
        <ul class="nav">
          <slot name="links">
            <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link"
            >
              <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                :link="subLink"
              >
              </sidebar-item>
            </sidebar-item>
          </slot>
        </ul>
      </div>
      <div class="static-content">
        <div class="settings-container">
          <router-link
            class="settings"
            to="/settings/usersSettings"
            v-if="store.getUser.userType?.name === 'Admin'"
            >Settings</router-link
          >
          <div v-if="store.getUser.userType?.name === 'Admin'">|</div>
          <!--          Help will be part of V2-->
          <!--          <div class="settings help">Help</div>-->
          <!--          <div>|</div>-->
          <div class="settings" @click="logout">Log out</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { useLoginStore } from "@/stores/loginStore";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "Vue LBD PRO",
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = [
          "",
          "blue",
          "azure",
          "green",
          "orange",
          "red",
          "purple",
          "black",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundImage: {
      type: String,
      default: "/static/img/HiloMainLogo.svg",
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: "/static/img/HiloMainLogo.svg",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const store = useLoginStore();
    return { store };
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },
  },
  methods: {
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar-wrapper");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
    logout() {
      localStorage.removeItem("jwtToken");
      this.store.$reset();
      this.$router.push({
        name: "Login",
      });
    },
  },
  mounted() {
    this.initScrollbar();
  },
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
.sidebar-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.static-content {
  flex-shrink: 0;
  padding-bottom: 10px;
}

.welcome-container {
  text-align: center;
  font-size: 18px;
  color: #404040;
  margin-bottom: 10px;
}

.welcome {
  font-weight: 600;
}

.hilo-logo-container {
  width: 240px;
  position: relative;
  border-radius: 10px;
  background-color: #404040;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto;
}

.hilo-logo {
  width: 158.9px;
  height: 42.3px;
}

.settings-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 7.5px;
  text-align: center;
  font-size: 15px;
  color: rgba(64, 64, 64, 0.5);
  padding: 10px 0;
}

.settings {
  position: relative;
  line-height: 25px;
  color: rgba(64, 64, 64, 0.5);
  text-decoration: none;
  cursor: pointer;
}

.help {
  cursor: default;
}

.settings:visited,
.settings:link,
.settings:active,
.settings:hover {
  color: rgba(64, 64, 64, 0.5);
}
</style>
<style scoped>
.scrollable-content {
  flex-grow: 1;
  overflow-y: auto;
  padding-right: 10px;
  box-sizing: border-box;
}

.scrollable-content::-webkit-scrollbar {
  width: 4px;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background-color: rgba(64, 64, 64, 0.5);
  border-radius: 10px;
}
</style>
